import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const consentAnalytics = () => {
  try {
    const p = JSON.parse(localStorage.getItem("onix_cookie_prefs"));
    return Boolean(p && p.analytics);
  } catch {
    return false;
  }
};

const sessionId = () => {
  try {
    let s = sessionStorage.getItem("onix_session");
    if (!s) {
      s = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      sessionStorage.setItem("onix_session", s);
    }
    return s;
  } catch {
    return null;
  }
};

const track = (path) => {
  if (path.startsWith("/admin") || !consentAnalytics()) return;
  axios
    .post(`${API}/track`, {
      path,
      referrer: document.referrer || null,
      lang: document.documentElement.lang || "es",
      screen: `${window.innerWidth}x${window.innerHeight}`,
      session_id: sessionId(),
      consent: true,
    })
    .catch(() => {});
};

export const Tracker = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    track(pathname);
  }, [pathname]);
  useEffect(() => {
    const onConsent = () => track(window.location.pathname);
    window.addEventListener("onix-consent-updated", onConsent);
    return () => window.removeEventListener("onix-consent-updated", onConsent);
  }, []);
  return null;
};
